import { preloadMatch } from '@ddt/game-engine';
import { assetCatalog } from './audio';
import { characterShowUrl, characterWingPlayer } from './itemIcons';
import { lookOf, lookTemplateIds, showWornOf } from './matchLooks';
import type { useCatalog } from './stores/catalog';

/** O que a sala sabe de cada jogador: só o necessário para montar o visual dele. */
export interface VersusPlayer {
  accountId: string;
  sex: boolean;
  style: string;
  weaponTemplateId: number;
}

/**
 * Aquece a tela de confronto enquanto a sala ainda está na tela: o catálogo das peças, as imagens do boneco de cada jogador (corpo, arma e asa) e a arte
 * que a partida vai pedir (`preloadMatch`, sem o mapa, que só chega com o estado da partida). Quando o confronto abre, os bonecos aparecem prontos.
 * Nunca rejeita: o que falhar aqui a própria tela baixa na hora.
 */
export async function preloadVersus(players: readonly VersusPlayer[], catalog: ReturnType<typeof useCatalog>, craterMaskBase?: string): Promise<void> {
  if (players.length === 0) return;
  await catalog.loadMany(players.flatMap(lookTemplateIds)).catch(() => undefined);
  const looks = players.map((p) => ({ player: p, look: lookOf(p, catalog.templates, catalog.weaponLevels) }));
  const tasks: Promise<unknown>[] = looks.flatMap(({ player, look }) => {
    const worn = showWornOf(look);
    return [characterShowUrl(player.sex ? 'm' : 'f', worn).catch(() => null), characterWingPlayer(worn).catch(() => null)];
  });
  tasks.push(
    assetCatalog()
      .then((assets) => preloadMatch({ assets, mapId: 0, craterMaskBase, players: looks.map(({ player, look }) => ({ accountId: player.accountId, sex: player.sex, weaponTemplateId: player.weaponTemplateId, look })) }))
      .catch(() => undefined),
  );
  await Promise.allSettled(tasks);
}
